// @flow

import type {Action} from '../../types'
import type {PlaceState} from '../types'
import type {SetPlacePayload} from '../actions/setPlace'

export function setPlaceReducer(state: PlaceState, action: Action<SetPlacePayload>): PlaceState {

  return {
    ...state,
    place: action.payload.place,
  }
}
